import React from 'react';

import useStorePriceDisplayConditions from '../../../hooks/usePriceDisplayConditions';
import {OrderLine} from '../../../transport/apiServiceResponse';
import {OrderLineSticker} from '../../../transport/apiServiceResponse';
import {renderSticker} from '../../../utils/functions';
import {renderStickerSmall} from '../../../utils/functions';
import {logger} from '../../../utils/logger';
import {getProductDisplayRules} from '../../../utils/rewards';
const OrderLineItemStickers = ({
  item,
  size,
  isProductScreen = false,
  stickers: stickersProp,
}: {
  item: OrderLine;
  size: 'small' | 'large';
  isProductScreen?: boolean;
  stickers?: OrderLineSticker[];
}) => {
  const {showMemberPrice} = useStorePriceDisplayConditions();
  const {presentAsPublicMemberProduct, presentAsPrivateMemberProduct} =
    getProductDisplayRules(item);

  // Use pre-filtered stickers if provided, otherwise filter internally (backward compat)
  const filteredStickers =
    stickersProp ??
    (item?.stickers || []).filter((sticker: OrderLineSticker) => {
      if (
        sticker.sticker_type === 'private_loyalty_member' &&
        !(showMemberPrice.privatePricing && presentAsPrivateMemberProduct)
      ) {
        return false;
      }
      // DIS-1590: a `public_loyalty_member` sticker is MFL's own advert — it ships to
      // a session-less caller with the member price printed on it — so it belongs to
      // the store/product layer, not the entitlement layer. It shows wherever the
      // store can honour a member price, signed in or not. `showMemberPrice`
      // deliberately is NOT used here: that predicate answers "is this shopper charged
      // the member price", which is a different question and would hide the advert
      // from every logged-out shopper. A `private_loyalty_member` sticker above still
      // requires entitlement, because a targeted price must never be advertised.
      if (
        sticker.sticker_type === 'public_loyalty_member' &&
        !(showMemberPrice.storeLoyaltyEnabled && presentAsPublicMemberProduct)
      ) {
        return false;
      }
      return true;
    });

  if (filteredStickers.length === 0) {
    return <></>;
  }

  const result = filteredStickers.map((sticker: OrderLineSticker) => {
    if (size === 'small') {
      return renderStickerSmall(sticker);
    } else if (size === 'large') {
      return renderSticker(sticker, isProductScreen);
    } else {
      logger.error('OrderLineItemStickers', 'Invalid size provided', {size});
      return null;
    }
  });

  return <>{result}</>;
};

export default OrderLineItemStickers;
